import React from "react";
import { styled } from "@iventis/styles";
import { CadUploadConfigControlPoint } from "@iventis/domain-model/model/cadUploadConfigControlPoint";
import { Asset } from "@iventis/domain-model/model/asset";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { initialSubjectContext, SubjectsContext } from "./state/subjects-context";
import { CadGeoEditor } from "./components/cad-placement/cad-geo-editor";
import { CadEditor } from "./components/cad-placement/cad-editor";
import { CadConfig } from "./types/cad-config";
import { CadStyle } from "./types/style";

export const CadEditorWrapper: React.FunctionComponent<{
    style: CadStyle;
    geoReferenced: boolean;
    sourceEpsgCode?: number | null;
    controlPoints?: CadUploadConfigControlPoint[];
    getGoogleMapBackgroundApiKey?: () => Promise<{ apiKey: string; session: string }>;
    onFinish: (cadConfig: CadConfig) => void;
    getMapBackgrounds?: () => Promise<Asset[]>;
    getSitemapVersionLevelAsset?: (levelId: string) => Promise<Asset>;
}> = ({ style, geoReferenced, sourceEpsgCode, onFinish, getGoogleMapBackgroundApiKey, controlPoints, getMapBackgrounds, getSitemapVersionLevelAsset }) => {
    const queryClient = new QueryClient({ defaultOptions: { queries: { refetchOnWindowFocus: false } } });

    return (
        <CadGeoreferencerContainer>
            <QueryClientProvider client={queryClient}>
                <SubjectsContext.Provider value={initialSubjectContext}>
                    {geoReferenced && (
                        <CadGeoEditor
                            style={style}
                            onFinish={onFinish}
                            sourceEpsgCode={sourceEpsgCode}
                            controlPoints={controlPoints}
                            getGoogleMapBackgroundApiKey={getGoogleMapBackgroundApiKey}
                            getMapBackgrounds={getMapBackgrounds}
                        />
                    )}
                    {!geoReferenced && (
                        <CadEditor
                            getGoogleMapBackgroundApiKey={getGoogleMapBackgroundApiKey}
                            onFinish={onFinish}
                            getMapBackgrounds={getMapBackgrounds}
                            getSitemapVersionLevelAsset={getSitemapVersionLevelAsset}
                        />
                    )}
                </SubjectsContext.Provider>
            </QueryClientProvider>
        </CadGeoreferencerContainer>
    );
};

const CadGeoreferencerContainer = styled.div`
    width: 100%;
    flex: 1;
    display: flex;
    min-height: 0px;

    p {
        margin: 0px;
    }
    .checkbox {
        height: 20px;
        width: 20px;
        cursor: pointer;
    }
`;
